/*! ******************************************************************************************************** *
 *
 * Copyright 2011-2020 Markus Schütz
 * Copyright 2025 Oidis
 *
 * SPDX-License-Identifier: BSD-2-Clause
 * The BSD-2-Clause license for this file can be found in the LICENSE.txt file included with this distribution
 * or at https://spdx.org/licenses/BSD-2-Clause.html#licenseText
 *
 * ********************************************************************************************************* */

import { EventDispatcher } from "./EventDispatcher.js";

export class Action extends EventDispatcher {
    constructor(args = {}) {
        super();

        this.icon = args.icon || "";
        this.tooltip = args.tooltip;

        if (args.onclick !== undefined) {
            this.onclick = args.onclick;
        }
    }

    onclick(event) {

    }

    pairWith(object) {

    }

    setIcon(newIcon) {
        let oldIcon = this.icon;

        if (newIcon === oldIcon) {
            return;
        }

        this.icon = newIcon;

        this.dispatchEvent({
            type: "icon_changed",
            action: this,
            icon: newIcon,
            oldIcon: oldIcon
        });
    }
}
